import { useAdCampaignDetail } from 'data/ad-campaign';
import React from 'react';

import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import GridContainer from 'creative-components/Grid/GridContainer';
import GridItem from 'creative-components/Grid/GridItem';

import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';

import AdCampaignPauseResumeButton from './AdCampaignPauseResumeButton';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 400,
  },
  settingContainer: {
    backgroundColor: '#F5F5F5',
    borderRadius: '12px',
    padding: '20px',
    margin: '0 0 30px',

    '& > h4': {
      fontSize: '16px',
      fontWeight: 600,
      color: theme.palette.darkGray.main,
    },
    '& > h5': {
      fontSize: '14px',
      color: theme.palette.gray.main,
      fontWeight: 500,
      margin: '6px 0 10px',
    },
  },
  settingInput: {
    maxWidth: '400px',
    fontWeight: 500,
  },
}));

type Props = {
  adCampaignId: string;
};

export default ({ adCampaignId }: Props) => {
  const classes = useStyles();
  const { isLoadingAdCampaign } = useAdCampaignDetail(adCampaignId);

  if (isLoadingAdCampaign) {
    return (
      <div className={classes.root}>
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <GridContainer justifyContent="flex-start">
        <GridItem xs={12}>
          <div className={classes.settingContainer}>
            <h4>General</h4>
            <h5>Manage your basic preferences and default configurations.</h5>

            <Box style={{ height: '40px' }} />

            <AdCampaignPauseResumeButton adCampaignId={adCampaignId} />
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
};
